exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".what-this[data-v-20f6f7a7] {\n  position: absolute;\n  right: 10px;\n  top: 54px;\n  cursor: pointer;\n  font-size: 13px;\n}", ""]);

// exports
